export interface TimeRangeSelectLastLoadedProps {
  /**
   * A string-based summary of the elapsed time since the relative time range was last updated.
   */
  lastLoadedMessage?: string;
  onLastLoadedMessageClick?: () => void;
}

/**
 * Message that communicates information about how "stale" relative time ranges are to the user.
 */
export const TimeRangeSelectLastLoaded = ({
  lastLoadedMessage,
  onLastLoadedMessageClick,
}: TimeRangeSelectLastLoadedProps) => {
  // Keyboard users can interact with the text input via keyboard already. This is purely an extra onClick for mouse
  // users who might click on this particular text.
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
  return <span onClick={onLastLoadedMessageClick}>{lastLoadedMessage}</span>;
};
